export const environment = {
	production: true,
	baseUrl: 'https://esteira.mamaquinas.com.br/',
	baseApi: 'ma-analisecredito/api/',
	company: 'johndeere/',
	jenkins:{
		urlView:'https://jenkins.maxiconsystems.com.br/job/esteira-view/buildWithParameters',
		urlApi:'https://jenkins.maxiconsystems.com.br/job/esteira-api/buildWithParameters',
		username:'trainee',
		password:'11daa39073c54cf8fe440a55dbd8e5528a',
		environment:'Producao'
	},
	gitLab:{
		sourceBranch:'homologacao',
		targetBranch:'main',
		url:'https://gitlab.maxiconsystems.com.br/api/v4/projects/43/merge_requests?target_branch=main&state=merged&per_page=1',
		headerType:'PRIVATE-TOKEN',
		headerToken:'zMV_Tnk9isCskvcj7zP7'
	}
};
